import {
  LAMBDATEST_CONCURRENCY_DATA_LOADING,
  LAMBDATEST_CONCURRENCY_DATA_SUCCESS,
  LAMBDATEST_CONCURRENCY_DATA_FAILED,
  LAMBDATEST_CONCURRENCY_DATA_CLEAR,
  LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING
} from "../actionTypeConstants/LambdaTestConcurrencyConstants";

const initialState = {
  lambdaTestConcurrency: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_CONCURRENCY_DATA_LOADING:
      return {
        ...state,
        lambdaTestConcurrency: {
          ...state.lambdaTestConcurrency,
          loading: true,
          silentLoading: false
        }
      };
    case LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING:
      return {
        ...state,
        lambdaTestConcurrency: {
          ...state.lambdaTestConcurrency,
          loading: false,
          silentLoading: true
        }
      };

    case LAMBDATEST_CONCURRENCY_DATA_SUCCESS:
      return {
        ...state,
        lambdaTestConcurrency: {
          ...state.lambdaTestConcurrency,
          loading: false,
          silentLoading: false,
          data: action.result.data
        }
      };

    case LAMBDATEST_CONCURRENCY_DATA_FAILED:
      return {
        ...state,
        lambdaTestConcurrency: {
          ...state.lambdaTestConcurrency,
          loading: false,
          silentLoading: false,
          error: action.error
        }
      };

    case LAMBDATEST_CONCURRENCY_DATA_CLEAR:
      return {
        ...state,
        lambdaTestConcurrency: initialState.lambdaTestConcurrency
      };

    default:
      return state;
  }
}
